module.exports = __webpack_public_path__ + "static/media/22-2.562b35d2.mp3";